import axios from 'axios';

const baseUrl = process.env.REACT_APP_QCX_API_BASE_URL! + '/diduimp/report/itens-di';

const generateSpreadsheetItensDi = async (
  token: string,
  unidadeId: number,
  dataInicio: string,
  dataFim: string,
  clienteId?: string,
  processos?: string[]
) => {
  const params = new URLSearchParams();
  params.set('inicio', dataInicio);
  params.set('fim', dataFim);
  if (clienteId) {
    params.set('cliente', clienteId);
  }
  if (processos && processos.length > 0) {
    params.set('processos', processos.join(','));
  }

  let message = null;

  try {
    const response = await axios.get(`${baseUrl}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
    });

    if (response.status === 200) {
      const file = new File([response.data], 'relatorioItensDi.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      message = await response.data.text();
    }
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.data) {
      message = await error.response.data.text();
    } else {
      message = 'Erro inesperado';
    }
  }

  return message;
};

export { generateSpreadsheetItensDi };
